import React from 'react';
import JITLoad from '~/helpers/jit-load';
import { useDataFromSlug, camelCaseKeys } from '~/helpers/page-data-utils';
const RECENT_DELTA_MS = 16 * 60 * 60 * 1000; // 16 hours
const LS_KEY = 'takeoverLastDisplay';
function deserialize(key) {
    try {
        return JSON.parse(window.localStorage.getItem(key) || 'null');
    }
    catch (_a) {
        return null;
    }
}
function useLocalStorage(key, defaultValue) {
    const storedValue = deserialize(key);
    const initialValue = storedValue === null ? defaultValue : storedValue;
    const [value, setValue] = React.useState(initialValue);
    React.useEffect(() => { var _a; return (_a = window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem(key, JSON.stringify(value)); }, [key, value]);
    return [value, setValue];
}
function useDisplayedRecently() {
    const [lastDisplay, setLastDisplay] = useLocalStorage(LS_KEY, 0);
    const msSince = Date.now() - Number(lastDisplay);
    const setDisplayed = React.useCallback(() => setLastDisplay(Date.now()), [setLastDisplay]);
    return [msSince < RECENT_DELTA_MS, setDisplayed];
}
export default function TakeOverDialogGateKeeper() {
    const rawData = camelCaseKeys(useDataFromSlug('donations/fundraiser'));
    const [data] = rawData ? [].concat(rawData) : [];
    const [displayedRecently, setDisplayed] = useDisplayedRecently();
    if (!data || displayedRecently) {
        return null;
    }
    return (React.createElement(JITLoad, { importFn: () => import('./import-takeover-dialog-content.js'), data: data, setDisplayed: setDisplayed }));
}
